export function twoDigits(number) {
  return number > 9 ? "" + number : "0" + number;
}
